import { create } from 'zustand'

/**
 * Submission Store
 */
export const useSubmissionStore = create((set, get) => ({
    // State
    filters: {
        status: null,
        archived: false,
        search: '',
        dateFrom: null,
        dateTo: null,
        page: 1,
        perPage: 20,
    },
    selectedSubmissions: [],
    currentSubmission: null,

    // Actions
    setFilter: (key, value) => {
        set((state) => ({
            filters: {
                ...state.filters,
                [key]: value,
                page: key !== 'page' ? 1 : value, // Reset page on filter change
            },
        }))
    },

    setFilters: (filters) => {
        set((state) => ({
            filters: { ...state.filters, ...filters, page: 1 },
        }))
    },

    resetFilters: () => {
        set({
            filters: {
                status: null,
                archived: false,
                search: '',
                dateFrom: null,
                dateTo: null,
                page: 1,
                perPage: 20,
            },
        })
    },

    setPage: (page) => {
        set((state) => ({
            filters: { ...state.filters, page },
        }))
    },

    selectSubmission: (id) => {
        set((state) => ({
            selectedSubmissions: state.selectedSubmissions.includes(id)
                ? state.selectedSubmissions.filter((s) => s !== id)
                : [...state.selectedSubmissions, id],
        }))
    },

    selectAllSubmissions: (ids) => {
        set({ selectedSubmissions: ids })
    },

    clearSelection: () => {
        set({ selectedSubmissions: [] })
    },

    setCurrentSubmission: (submission) => {
        set({ currentSubmission: submission })
    },
}))

export default useSubmissionStore
